module.exports = "/packs/step_title-34c5a5a3b0752a55e800ce036260d08d.png";